import { mapFirstPerson } from '../DataTypes/personMapper';
import { mapBasePageProperties } from './basePagePropertiesMapper';
import logger from '3-foundation/Logging/logger';

interface Props extends Umbraco.BasePage {
	heading?: string;
	teaser?: { markup: string };
	author?: Umbraco.Person[];
	syncDataPageId?: string;
	syncDataParents?: string;
}

export const mapContentPageProperties = async (
	properties: Props,
	pageId: string,
	siteId: string,
	locale: string,
	site: Site.Site,
): Promise<Content.ContentPageProperties> => {
	const { syncDataPageId, syncDataParents } = properties ?? {};
	const guids = [syncDataPageId, syncDataParents].filter(Boolean).join(',');

	// Split the guids string into an array and filter out empty strings
	const guidArray = guids
		.split(',')
		.map((guid) => guid.trim())
		.filter(Boolean);

	// Find all offices where relatedsubjects contains any of the guids
	const contactOffices: Site.Office[] = [];
	if (guidArray.length > 0 && site.siteContacts) {
		site.siteContacts.forEach((contactData) => {
			contactData.offices?.forEach((office) => {
				const hasMatchingSubject = office.relatedsubjects?.some((subject) => guidArray.includes(subject));
				if (hasMatchingSubject) {
					contactOffices.push(office);
				}
			});
		});
	}

	try {
		return {
			...(await mapBasePageProperties(properties, siteId, locale)),
			heading: properties.heading,
			teaser: properties.teaser?.markup || null,
			author: mapFirstPerson(properties.author ?? []),
			contactOffices: contactOffices ?? null,
		};
	} catch (e) {
		logger.error(`Could not map ContentPage Properties \nCause: ${e}`);
		throw new Error(`Could not map ContentPage Properties \nCause: ${e}`, e);
	}
};
